import { render, staticRenderFns } from "./contract-create-success.vue?vue&type=template&id=1afb6b30&scoped=true"
import script from "./contract-create-success.vue?vue&type=script&lang=js"
export * from "./contract-create-success.vue?vue&type=script&lang=js"
import style0 from "./contract-create-success.vue?vue&type=style&index=0&id=1afb6b30&prod&lang=less&scoped=true"
import style1 from "./contract-create-success.vue?vue&type=style&index=1&id=1afb6b30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb6b30",
  null
  
)

export default component.exports